import { ApiService } from "./ApiService"

export class ResellerService {

    static uri = '/agensi/reseller';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }
}